import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'lodash';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';

const ProductListNavigationCategories = ({ categories, className }) => (
  <div className={className}>
    <ul>
      {
        map(categories, ({ id, is_active, path, name }) =>
          <li key={id} className={classNames('nav-category', { active: is_active })}>
            <Link to={path}
              dangerouslySetInnerHTML={{ __html: name }}
            />
          </li>
        )
      }
    </ul>
  </div>
);

ProductListNavigationCategories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string,
    is_active: PropTypes.bool,
    name: PropTypes.string
  })).isRequired,
  className: PropTypes.string
};

export default ProductListNavigationCategories;
